import { useId, useState } from 'react';
import { Button } from '../../ui/Button';
import { Field, Input } from '../../ui/Form';
import { useStrings } from '../../tenant/TenantProvider';
import { trackerApi } from '../../lib/trackerApi';

const FIELDS = [
  { key: 'leetcode', lock: 'leetcodeLocked', label: 'profiles.leetcode', hint: 'profiles.leetcodeHint' },
  { key: 'codeforces', lock: 'codeforcesLocked', label: 'profiles.codeforces', hint: 'profiles.codeforcesHint' },
  { key: 'codechef', lock: 'codechefLocked', label: 'profiles.codechef', hint: 'profiles.codechefHint' },
];

export function CodingProfilesForm({ profile, onSaved, onSkip, showSkip = false }) {
  const t = useStrings();
  const baseId = useId();
  const [links, setLinks] = useState({
    leetcode: profile?.leetcode || '',
    codeforces: profile?.codeforces || '',
    codechef: profile?.codechef || '',
  });
  const [fieldError, setFieldError] = useState(null);
  const [formError, setFormError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [skipping, setSkipping] = useState(false);

  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    setFieldError(null);
    setFormError(null);
    const response = await trackerApi.save(links);
    setSaving(false);
    if (!response.success) {
      if (response.code === 'INVALID_PROFILE_URL' && response.details?.field) {
        setFieldError({ field: response.details.field, message: t('profiles.invalid') });
      } else {
        setFormError(response.error);
      }
      return;
    }
    onSaved(response.data);
  };

  const skip = async () => {
    setSkipping(true);
    setFormError(null);
    const response = await trackerApi.skip();
    setSkipping(false);
    if (!response.success) {
      setFormError(response.error);
      return;
    }
    onSkip(response.data);
  };

  return (
    <form className="profile-links" onSubmit={save}>
      {FIELDS.map(({ key, lock, label, hint }) => {
        const id = `${baseId}-${key}`;
        const invalid = fieldError?.field === key;
        const locked = Boolean(profile?.[lock]);
        return (
          <Field
            key={key}
            label={t(label)}
            hint={invalid ? null : locked ? t('profiles.fieldLocked') : t(hint)}
            error={invalid ? fieldError.message : null}
            htmlFor={id}
          >
            <Input
              id={id}
              name={key}
              type="url"
              inputMode="url"
              autoComplete="url"
              placeholder={t(hint)}
              value={links[key]}
              invalid={invalid}
              disabled={locked}
              onChange={(event) => setLinks((current) => ({ ...current, [key]: event.target.value }))}
            />
          </Field>
        );
      })}
      {formError && (
        <p className="field__error" role="alert">
          {formError}
        </p>
      )}
      <div className="profile-links__actions">
        <Button type="submit" variant="primary" loading={saving}>
          {t('profiles.save')}
        </Button>
        {showSkip && (
          <Button type="button" onClick={skip} loading={skipping}>
            {t('profiles.skip')}
          </Button>
        )}
      </div>
    </form>
  );
}
